import { useMemo, type ReactNode } from "react";
import { useLinkedEmployeeState } from "@/hooks/useLinkedEmployee";
import { useEmployeeFunctionalCapacityGateState } from "@/hooks/useEmployeeFunctionalCapacityGate";
import { EmployeeSessionContext } from "@/contexts/employeeSessionContext";

/** Single source for linked employee + FC gate on team member shell (avoids duplicate fetches). */
export function EmployeeSessionProvider({
  enabled,
  orgId,
  children,
}: {
  enabled: boolean;
  orgId: string | null;
  children: ReactNode;
}) {
  const linked = useLinkedEmployeeState();
  const fcGate = useEmployeeFunctionalCapacityGateState(enabled, orgId, linked);
  const value = useMemo(
    () => ({ linked, fcGate }),
    [linked, fcGate],
  );
  return (
    <EmployeeSessionContext.Provider value={value}>{children}</EmployeeSessionContext.Provider>
  );
}
